export const updateBarData = {
  brand: "黑料地址网",
  checkedAt: "2026.09.11 09:20",
  online: 6,
  total: 7,
  ticker: [
    "镜像线路 B 已完成连通性校验，可正常访问",
    "备用入口新增一个全球加速节点",
    "镜像线路 C 正在维护，请优先使用主推入口",
    "本页每 30 分钟自动更新一次可用域名",
  ],
};

export const heroData = {
  eyebrow: "防封备用 · 实时更新",
  title: "黑料地址",
  titleAccent: "镜像站 · 备用入口",
  lede:
    "这里是黑料地址的地址索引页。我们持续整理黑料地址镜像站与黑料地址备用入口，即使换域名也能找到，确保访问不中断。收藏本页，随时获取最新镜像地址。",
  stats: [
    { label: "在线入口", value: "6 / 7" },
    { label: "平均延迟", value: "42ms" },
    { label: "最近校验", value: "09:20" },
  ],
  primaryCta: "进入最新可用入口",
  secondaryCta: "复制备用入口",
  backupHost: "hl-address-backup.home",
};

export const featuredEntry = {
  badge: "今日主推",
  title: "主站镜像 · 高速线路 A",
  host: "hl-mirror-a.home",
  region: "全球加速",
  status: "在线",
  latency: "38ms",
  updated: "今天 09:20 校验通过",
  desc:
    "当前连通性最好的一条线路，优先推荐作为日常访问入口。线路采用多节点调度，稳定性高，适合长期收藏作为首选镜像。",
  cta: "进入该入口",
  image:
    "https://readdy.ai/api/search-image?query=Warm%20cream%20studio%20still%20life%20with%20a%20neat%20stack%20of%20folded%20editorial%20magazines%2C%20a%20bold%20vermilion%20ribbon%20accent%2C%20deep%20olive%20shadows%2C%20soft%20natural%20window%20light%2C%20minimalist%20product%20photography%2C%20calm%20warm%20palette%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=800&seq=hladdr-featured-01&orientation=landscape",
};

export type MirrorEntry = {
  id: string;
  name: string;
  host: string;
  region: string;
  status: "在线" | "繁忙";
  latency: string;
  updated: string;
  note: string;
  image: string;
};

export const mirrorEntries: MirrorEntry[] = [
  {
    id: "m1",
    name: "镜像线路 B",
    host: "hl-mirror-b.home",
    region: "亚太节点",
    status: "在线",
    latency: "45ms",
    updated: "今天 09:20",
    note: "备用入口首选，晚高峰表现稳定。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20art%20with%20warm%20cream%20paper%20background%2C%20bold%20vermilion%20arcs%20and%20deep%20olive%20geometric%20blocks%2C%20risograph%20print%20grain%20texture%2C%20minimalist%20magazine%20composition%2C%20soft%20paper%20fibers%2C%20high%20detail%2C%20balanced%20warm%20color%20harmony&width=1000&height=1200&seq=hladdr-mirror-01&orientation=portrait",
  },
  {
    id: "m2",
    name: "镜像线路 C",
    host: "hl-mirror-c.home",
    region: "欧美节点",
    status: "繁忙",
    latency: "112ms",
    updated: "今天 08:40",
    note: "正在维护中，建议稍后再试。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20poster%20art%20on%20deep%20olive%20field%20with%20cream%20typographic%20blocks%20and%20a%20vermilion%20circle%20accent%2C%20subtle%20risograph%20grain%2C%20minimalist%20print%20layout%2C%20calm%20slow%20composition%2C%20high%20detail%2C%20refined%20warm%20earthy%20tones&width=1000&height=1200&seq=hladdr-mirror-02&orientation=portrait",
  },
  {
    id: "m3",
    name: "镜像线路 D",
    host: "hl-mirror-d.home",
    region: "东南亚节点",
    status: "在线",
    latency: "58ms",
    updated: "今天 09:10",
    note: "移动网络访问更流畅。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20with%20warm%20sand%20gradient%20and%20layered%20paper%20cut%20shapes%20in%20vermilion%20and%20olive%2C%20soft%20grain%20texture%2C%20minimalist%20magazine%20aesthetic%2C%20generous%20negative%20space%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=1000&height=1200&seq=hladdr-mirror-03&orientation=portrait",
  },
  {
    id: "m4",
    name: "镜像线路 E",
    host: "hl-mirror-e.home",
    region: "全局加速",
    status: "在线",
    latency: "49ms",
    updated: "昨天 23:50",
    note: "长线路备份，作为长期备用收藏。",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20cover%20on%20cream%20paper%20with%20overlapping%20translucent%20vermilion%20and%20olive%20forms%2C%20risograph%20print%20texture%2C%20calm%20minimalist%20composition%2C%20soft%20light%2C%20high%20detail%2C%20warm%20refined%20harmony&width=1000&height=1200&seq=hladdr-mirror-04&orientation=portrait",
  },
];

export const hotRanking = [
  { rank: 1, name: "主站镜像 · 高速线路 A", host: "hl-mirror-a.home", visits: "128.4k", trend: "+12%", heat: 96 },
  { rank: 2, name: "镜像线路 B", host: "hl-mirror-b.home", visits: "96.7k", trend: "+8%", heat: 82 },
  { rank: 3, name: "镜像线路 D", host: "hl-mirror-d.home", visits: "74.2k", trend: "+5%", heat: 68 },
  { rank: 4, name: "镜像线路 E", host: "hl-mirror-e.home", visits: "51.9k", trend: "-2%", heat: 52 },
  { rank: 5, name: "镜像线路 C", host: "hl-mirror-c.home", visits: "38.1k", trend: "-9%", heat: 36 },
];

export const guideSteps = [
  {
    step: "01",
    title: "先记规律，再记域名",
    desc:
      "黑料地址的镜像域名会轮换，但命名规则相对固定。记住主域名特征，比死记某一个地址更可靠。",
  },
  {
    step: "02",
    title: "把本页收进收藏夹",
    desc:
      "把当前页面设为书签。当原有入口失效时，回来刷新一次，就能获取最新的可用镜像地址。",
  },
  {
    step: "03",
    title: "入口打不开就换一条",
    desc:
      "上方列表按状态与延迟排序，主推入口优先使用。若某条繁忙或维护，直接切换其它备用入口即可。",
  },
];

export const faqs = [
  {
    q: "黑料地址为什么经常更换域名？",
    a: "域名更换是为了保证长期可访问性。当某条线路受到网络波动影响时，我们会切换到新的域名并同步更新到本页，让访问尽量不中断。",
  },
  {
    q: "黑料地址备用入口在哪里获取？",
    a: "备用入口集中在本页的镜像列表中。每条线路都标注了当前状态、所在区域与延迟，你可以按需选择，也可以一次收藏多个作为备份。",
  },
  {
    q: "打不开黑料地址镜像站怎么办？",
    a: "先刷新本页获取最新地址，再尝试列表中状态为「在线」的线路。如果多条线路同时异常，通常是短暂波动，稍后重试即可。",
  },
  {
    q: "收藏哪个地址最稳妥？",
    a: "建议收藏本地址索引页本身，而不是某一个具体线路。页面会持续更新，无论域名如何变化，你都能从这里找到当时的可用入口。",
  },
  {
    q: "页面上的地址多久更新一次？",
    a: "系统每 30 分钟自动校验一次连通性，并在有变化时更新列表。顶部更新条会显示最近一次校验时间，供你判断信息新鲜度。",
  },
];